import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { AbandonedCallsParametersFormService } from '@ndt/reports/abandoned-calls/services/abandoned-calls-parameters-form.service';
import { DailyCallVolumeParametersFormService } from '@ndt/reports/daily-call-volume/services/daily-call-volume-parameters-form.service';
import { ExtensionDetailParametersFormService } from '@ndt/reports/extension-detail/services/extension-detail-parameters-form.service';
import { ExtensionSummaryParametersFormService } from '@ndt/reports/extension-summary/services/extension-summary-parameters-form.service';
import { HourlyCallVolumeParametersFormService } from '@ndt/reports/hourly-call-volume/services/hourly-call-volume-parameters-form.service';
import { HuntGroupsParametersFormService } from '@ndt/reports/hunt-groups/services/hunt-groups-parameters-form.service';
import { InboundCallsByPhoneNumberParametersFormService } from '@ndt/reports/inbound-calls-by-phone-number/services/inbound-calls-report-parameters-form.service';
import { InternationalCallsParametersFormService } from '@ndt/reports/international-calls/services/international-calls-parameters-form.service';
import { MissedCallsParametersFormService } from '@ndt/reports/missed-calls/services/missed-calls-parameters-form.service';
import { SystemInternationalCallsParametersFormService } from '@ndt/reports/system-international-calls/services/system-international-calls-parameters-form.service';
import { TopCallersParametersFormService } from '@ndt/reports/top-callers/services/top-callers-parameters-form.service';
import { WeekdayCallVolumeParametersFormService } from '@ndt/reports/weekday-call-volume/services/weekday-call-volume-parameters-form.service';
import { Store } from '@ngrx/store';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import { Tiles } from 'src/app/pages/tiles/containers/tile-wrapper/tile-component-accessor';
import { CallParkingParametersFormService } from 'src/app/pages/tiles/views/call-parking/services/call-parking-parameters-form.service';
import { ClockParametersFormService } from 'src/app/pages/tiles/views/clock/services/clock-parameters-form.service';
import { NdtWaitTimesParametersFormService } from 'src/app/pages/tiles/views/ndt-wait-times-graph-tile/services/ndt-wait-times-parameters-form.service';
import { PhoneQueuesParametersFormService } from 'src/app/pages/tiles/views/phone-queues/services/phone-queues-parameters-form.service';
import { QueueMembersParametersFormService } from 'src/app/pages/tiles/views/queue-members/services/queue-members-parameters-form.service';
import { Reports } from '../../reports.enum';
import { ReportParameterFormService } from './report-parameter-form.service';

@Injectable({ providedIn: 'root' })
export class ReportParameterFormFactoryService {
   constructor(
      private fb: UntypedFormBuilder,
      private dateTimeAdapter: LcsDateTimeAdapter<Date>,
      private store: Store
   ) {}

   getService(report: Reports | Tiles): ReportParameterFormService<any> {
      switch (report) {
         case Reports.ExtensionDetail:
            return new ExtensionDetailParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.ExtensionSummary:
            return new ExtensionSummaryParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.HourlyCallVolume:
            return new HourlyCallVolumeParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.DailyCallVolume:
            return new DailyCallVolumeParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.TopCallers:
            return new TopCallersParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.WeekDayCallVolume:
            return new WeekdayCallVolumeParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.InternationalCalls:
            return new InternationalCallsParametersFormService(this.fb, this.dateTimeAdapter, this.store);
         case Reports.MissedCalls:
            return new MissedCallsParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.HuntGroupExtension:
            return new HuntGroupsParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.AbandonedCalls:
            return new AbandonedCallsParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.InboundCallsByPhoneNumber:
            return new InboundCallsByPhoneNumberParametersFormService(this.fb, this.dateTimeAdapter);
         case Reports.SystemInternationalCalls:
            return new SystemInternationalCallsParametersFormService(this.fb, this.dateTimeAdapter, this.store);
         case Tiles.Clock:
            return new ClockParametersFormService(this.fb, this.dateTimeAdapter);
         case Tiles.CallParking:
            return new CallParkingParametersFormService(this.fb, this.dateTimeAdapter);
         case Tiles.QueueMembers:
            return new QueueMembersParametersFormService(this.fb, this.dateTimeAdapter);
         case Tiles.PhoneQueues:
            return new PhoneQueuesParametersFormService(this.fb, this.dateTimeAdapter);
         case Tiles.NDTWaitTimesGraph:
            return new NdtWaitTimesParametersFormService(this.fb, this.dateTimeAdapter);
         default:
            throw new Error('Unknown report type: ' + report);
      }
   }
}
